<script setup lang="ts">
    const props = withDefaults(
        defineProps<{
            field1Class?: string;
            field2Class?: string;
            field3Class?: string;
        }>(),
        {
            field1Class: 'w-full',
            field2Class: 'w-full',
            field3Class: 'w-full',
        }
    );
</script>

<template>
    <div class="flex space-x-4">
        <div :class="field1Class">
            <slot name="field-1"></slot>
        </div>
        <div :class="field2Class">
            <slot name="field-2"></slot>
        </div>
        <div :class="field3Class">
            <slot name="field-3"></slot>
        </div>
    </div>
</template>
